var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',[_c('EmployeeLeaveChart',{ref:"EmployeeChart",attrs:{"chart-data":_vm.leaves}}),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.employeeLeaves}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }